module.exports = __webpack_public_path__ + "static/img/MC.a12bdd5e.png";